import { createTimingChannel } from '@atlassian/commerce-events-telemetry-react/timing';

var _createTimingChannel = createTimingChannel(),
    FormStartTimeRecorder = _createTimingChannel.StartTimeRecorder,
    FormStartTimeProvider = _createTimingChannel.StartTimeProvider,
    useFormStartTimeRef = _createTimingChannel.useStartTimeRef;

export { FormStartTimeRecorder, FormStartTimeProvider, useFormStartTimeRef };